import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ContainerLocation = styled("div")(() => ({
  maxWidth: "150px",
}));

export const NoDataContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
}));

export const NoDataTitle = styled("span")(() => ({
  fontSize: "16px",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  color: colors.gray500,
}));
